import { useCallback, useState } from 'react';

import PropTypes from 'prop-types';

import './DropDownMenu.css';

import useOutClick from '../../hook/useOutClick';
import { buildClass } from '../../libs/classes';

export const dropDownTemplate = {
	small: 'small',
	small_left: 'small',
	small_right: 'small-right',
};

/**
 * Drop-down menu
 */
const DropDownMenu = ({ template, children }) => {
	const [isOpen, setIsOpen] = useState(false);

	const ref = useOutClick((_event) => {
		if (isOpen) {
			setIsOpen(false);
		}
	});

	const getClassName = useCallback(() => {
		let className = buildClass('drop-down-menu').add(template, `template-${template}`).add(isOpen, 'show');
		return className;
	}, [template, isOpen]);

	function show() {
		setIsOpen(true);
	}

	function close() {
		setIsOpen(false);
	}

	return (
		<div className={getClassName()} ref={ref}>
			<div className="drop-down-icon" onClick={show} />
			{isOpen ? (
				<div className="drop-down-items" onClick={close}>
					{children}
				</div>
			) : null}
		</div>
	);
};

DropDownMenu.propTypes = {
	// Drop-down menu template (see dropDownTemplate)
	template: PropTypes.oneOf(Object.values(dropDownTemplate)).isRequired,
	// Content of drop-down menu (MenuItems)
	children: PropTypes.node.isRequired,
};

export default DropDownMenu;
